import React from 'react';
import { SystemCategory } from '../components';

export default () => {
    return (
        <SystemCategory.Home />
    )
}